import { makeAutoObservable, runInAction } from "mobx";
import { createScreenNodes, searchPolygon } from "../services/ScreenApi";
import { Geometry } from "geojson";
import { ScreenNodes, ScreenSearchPolygonResponse } from "../models/Screen";
import { RootStore } from "../../shared/stores/RootStore";

export class ScreenStore {
  rootStore;
  selectedWays: string[] = [];
  waysResponse?: ScreenSearchPolygonResponse;
  showCheckList = false;
  submitted = false;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  resetState() {
    runInAction(() => {
      this.selectedWays = [];
      this.waysResponse = undefined;
      this.showCheckList = false;
      this.submitted = false;
    });
  }

  addSelectedWay(way: string) {
    runInAction(() => {
      this.selectedWays = [...this.selectedWays, way];
    });
  }

  removeSelectedRoute(osaWayName: string) {
    runInAction(() => {
      this.selectedWays = this.selectedWays.filter(
        (item) => item !== osaWayName
      );
    });
  }

  async searchPolygon(rings: Geometry) {
    const response = await searchPolygon(rings);
    runInAction(() => {
      if (response.data.osaWayNames.length > 0) {
        this.waysResponse = response.data;
        this.showCheckList = true;
      } else {
        this.waysResponse = undefined;
      }
    });
  }

  async createScreenNodes(projectId: string, nodes: ScreenNodes[]) {
    await createScreenNodes({ projectId, nodes });
    runInAction(() => {
      this.submitted = true;
    });
  }
}
